import { mapApiDataToUseCaseHome } from '@/lib/cms-mappers/use-case-home.mappers';
import { locales } from '@/config/locales';

import type { FUseCaseHomeTemplateProps } from '@/components/templates/FUseCaseHomeTemplate.vue';

/**
 * Returns homepage use case data fetched from CMS (Strapi)
 */
export async function useCmsUseCaseHome(): UseCmsResponse<FUseCaseHomeTemplateProps> {
  const useCaseHome = useStrapi('use-case-home', {
    localesSubset: locales,
    queryParams: {
      populate: [
        'video_placeholder_image',
        'featured_use_case.hero.image_background',
        'featured_guide.image',
        'images',
      ].join(','),
    },
  });

  const useCasesCards = useStrapi('use-cases', {
    localesSubset: locales,
    queryParams: {
      populate: ['city_name', 'lifestyle_image', 'title_short'],
    },
  });

  const [useCaseHomeData, useCasesCardsData] = await Promise.all([
    useCaseHome,
    useCasesCards,
  ]);

  const mappedData = computed(() =>
    mapApiDataToUseCaseHome(
      useCaseHomeData.data.value?.data,
      useCasesCardsData.data.value?.data
    )
  );

  return {
    data: mappedData,
    error: useCaseHomeData.error || useCasesCardsData.error,
    pending: useCaseHomeData.pending || useCasesCardsData.pending,
    refresh: useCaseHomeData.refresh || useCasesCardsData.refresh,
  };
}
